export function setupCSP(): void {
  const nonce = (window as any).__nonce;
  const cspMeta = document.createElement("meta");
  cspMeta.httpEquiv = "Content-Security-Policy";

  const styleSources = [
    "'self'",
    "'unsafe-inline'",
    process.env.VUE_APP_HYPERPAY_URL,
    "https://fonts.googleapis.com",
    "https://unpkg.com",
    "https://*.hotjar.com",
  ];

  const scriptSources = [
    "'self'",
    "'unsafe-inline'",
    "'unsafe-eval'",
    `'nonce-${nonce}'`,
    "'strict-dynamic'",
    process.env.VUE_APP_HYPERPAY_URL,
    "https://maps.googleapis.com",
    "https://www.googletagmanager.com",
    "https://unpkg.com",
    "https://www.google-analytics.com",
    "https://mpsnare.iesnare.com",
    "https://applepay.cdn-apple.com",
    "https://*.hotjar.com",
    "https://analytics.google.com",
    "https://region1.google-analytics.com",
    "https://www.googleadservices.com",
    "https://googleads.g.doubleclick.net",
    "https://stats.g.doubleclick.net",
    "https://pagead2.googlesyndication.com",
    "https://www.gstatic.com",
    "https://connect.facebook.net",
    "https://www.facebook.com",
    "https://sc-static.net",
    "https://tr.snapchat.com",
    "https://static.ads-twitter.com",
    "https://ads-twitter.com",
    "https://ads-api.twitter.com",
    "https://analytics.twitter.com",
    "https://t.co",
  ];

  const frameSources = [
    "'self'",
    process.env.VUE_APP_KEYCLOAK_URL,
    process.env.VUE_APP_HYPERPAY_URL,
    "https://www.google.com",
    "https://www.googletagmanager.com",
    "https://*.mastercard.com",
    "https://eu-prod.ppipe.net/",
    "https://applepay.cdn-apple.com",
    "https://*.hotjar.com",
    "https://*.snapchat.com",
  ];

  const connectSources = [
    "'self'",
    "data:",
    "wss://*",
    process.env.VUE_APP_API_URL,
    process.env.VUE_APP_KEYCLOAK_URL,
    process.env.VUE_APP_HYPERPAY_URL,
    "https://*.googleapis.com",
    "https://region1.google-analytics.com",
    "https://www.google-analytics.com",
    "https://www.google.com",
    "https://ad.doubleclick.net",
    "https://*.mastercard.com",
    "https://applepay.cdn-apple.com",
    "https://*.hotjar.com",
    "https://*.hotjar.io",
    "https://www.googletagmanager.com",
    "https://analytics.google.com",
    "https://www.googleadservices.com",
    "https://googleads.g.doubleclick.net",
    "https://stats.g.doubleclick.net",
    "https://pagead2.googlesyndication.com",
    "https://www.gstatic.com",
    "https://connect.facebook.net",
    "https://www.facebook.com",
    "https://sc-static.net",
    "https://*.snapchat.com",
    "https://static.ads-twitter.com",
    "https://ads-twitter.com",
    "https://ads-api.twitter.com",
    "https://analytics.twitter.com",
    "https://t.co",
  ];

  const imageSources = [
    "'self'",
    "data:",
    "blob:",
    process.env.VUE_APP_API_URL,
    process.env.VUE_APP_HYPERPAY_URL,
    "https://www.googletagmanager.com",
    "https://objectstorage.me-jeddah-1.oraclecloud.com",
    "https://*.googleapis.com",
    "https://*.gstatic.com",
    "https://www.google.com",
    "https://www.google.com.pk",
    "https://www.google.com.sa",
    "https://region1.google-analytics.com",
    "https://applepay.cdn-apple.com",
    "https://api.shefa.sa",
    "https://*.hotjar.com",
    "https://*.picsum.photos",
    "https://picsum.photos",
    "https://www.google-analytics.com",
    "https://analytics.google.com",
    "https://www.googleadservices.com",
    "https://googleads.g.doubleclick.net",
    "https://stats.g.doubleclick.net",
    "https://pagead2.googlesyndication.com",
    "https://www.gstatic.com",
    "https://connect.facebook.net",
    "https://www.facebook.com",
    "https://sc-static.net",
    "https://tr.snapchat.com",
    "https://static.ads-twitter.com",
    "https://ads-twitter.com",
    "https://ads-api.twitter.com",
    "https://analytics.twitter.com",
    "https://t.co",
  ];

  const fontSources = ["'self'", "data:", "https://fonts.gstatic.com", "https://*.hotjar.com"];

  const workerSources = ["'self'", "blob:", process.env.VUE_APP_HYPERPAY_URL];

  const childSources = [
    "'self'",
    "blob:",
    process.env.VUE_APP_HYPERPAY_URL,
    "https://*.mastercard.com",
  ];

  cspMeta.content = `
    default-src 'self';
    style-src ${styleSources.join(" ")};
    script-src ${scriptSources.join(" ")};
    worker-src ${workerSources.join(" ")}; 
    child-src ${childSources.join(" ")};
    frame-src ${frameSources.join(" ")};
    connect-src ${connectSources.join(" ")};
    img-src ${imageSources.join(" ")};
    font-src ${fontSources.join(" ")};
  `;

  document.head.appendChild(cspMeta);
}

export function setupDebugCSP(): void {
  const nonce = (window as any).__nonce;
  const cspMeta = document.createElement("meta");
  cspMeta.httpEquiv = "Content-Security-Policy-Report-Only";

  cspMeta.content = `
    default-src 'self';
    script-src 'self' 'unsafe-inline' 'unsafe-eval' 'nonce-${nonce}' https: http:;
    style-src 'self' 'unsafe-inline' https: http:;
    img-src 'self' data: https: http:;
    connect-src 'self' data: https: http: ws: wss:; 
    frame-src 'self' https: http:;
    font-src 'self' data: https: http:;
    object-src 'none';
    worker-src 'self' blob: https: http:;
    child-src 'self' blob: https: http:;
  `;

  document.head.appendChild(cspMeta);
}

export function initializeCSP(debug = false): void {
  if (debug) {
    setupDebugCSP();
  } else {
    setupCSP();
  }
}

export default initializeCSP;
